<template>
  <div class="bookings w-100">
    <h3
      v-if="!$store.state.reservations.length"
      class="my-5"
    >
      No se encontraron reservas.
    </h3>
    <template v-else>
      <div class="board-search">
        <input
          type="text"
          placeholder="BUSCA TU SALIDA POR DESTINO, FECHA O NOMBRE DE PASAJERO"
          v-model="search"
        >
      </div>
      <div class="tabs">
        <template v-for="item in tabs">
          <router-link
            :key="item.link.query.tab"
            v-if="reservations[item.link.query.tab].length"
            class="tab"
            :class="{ active: tab == item.link.query.tab }"
            :to="item.link"
            exact
            append
          >
            {{ item.text }}
          </router-link>
        </template>
      </div>
    </template>
    <table
      v-if="reservations[tab].length"
      class="tbl"
    >
      <template v-if="tab == 'acredited'">
        <tr>
          <th><span>SALIDA</span></th>
          <th
            class="txt-left"
            colspan="2"
          >
            <span>NÚMERO</span>
          </th>
          <th><span>TITULAR</span></th>
          <th><span>PASAJEROS</span></th>
          <th><span>VENCIMIENTO</span></th>
          <th><span>PRECIO</span></th>
        </tr>
        <tr
          v-for="(item, i) in reservations.acredited"
          :key="i"
          :class="'reservation-' + item.status"
        >
          <td>
            <span>{{ item.departure_alias }} {{ item.departure_name }}</span>
          </td>
          <td class="txt-left">
            <span>{{ item.id }}</span>
          </td>
          <td>
            <router-link
              class="tbl-link nowrap"
              :to="item.id"
              append
            >
              VER DETALLE
            </router-link>
          </td>
          <td>
            <span class="nowrap">{{ item.holder }}</span>
          </td>
          <td>
            <span class="nowrap">{{ item.completed_passengers ? item.paxs : 'COMPLETAR DATOS' }}</span>
          </td>
          <td>
            <span>{{ item.expiration }}</span>
          </td>
          <td>
            <strong class="nowrap">{{ item.price_currency }} {{ item.price_final }}</strong>
          </td>
        </tr>
      </template>
      <template v-if="tab == 'finalized'">
        <tr>
          <th><span>SALIDA</span></th>
          <th
            class="txt-left"
            colspan="2"
          >
            <span>NÚMERO</span>
          </th>
          <th><span>TITULAR</span></th>
          <th><span>PASAJEROS</span></th>
          <th><span>VENCIMIENTO</span></th>
          <th><span>PRECIO</span></th>
        </tr>
        <tr
          v-for="(reservation, i) in reservations.finalized"
          :key="i"
          :class="'reservation-' + reservation.status"
        >
          <td>
            <span>
              {{ reservation.departure_alias }} {{ reservation.departure_name }}
            </span>
          </td>
          <td class="txt-left">
            <span>{{ reservation.id }}</span>
          </td>
          <td>
            <router-link
              class="tbl-link nowrap"
              :to="reservation.id"
              append
            >
              VER DETALLE
            </router-link>
          </td>
          <td>
            <span class="nowrap">{{ reservation.holder }}</span>
          </td>
          <td>
            <span class="nowrap">{{
              reservation.completed_passengers
                ? reservation.price_passengers
                : 'COMPLETAR DATOS'
            }}</span>
          </td>
          <td>
            <span>{{ reservation.expiration }}</span>
          </td>
          <td>
            <strong class="nowrap">
              {{ reservation.price_currency }} {{ reservation.price_final }}
            </strong>
          </td>
        </tr>
      </template>
      <template v-if="tab == 'canceled'">
        <tr>
          <th><span>SALIDA</span></th>
          <th><span>NÚMERO</span></th>
          <th>&nbsp;</th>
        </tr>
        <tr
          v-for="(item, i) in reservations.canceled"
          :key="i"
          :class="'reservation-' + item.status"
        >
          <td>
            <span>{{ item.departure_alias }} {{ item.departure_name }}</span>
          </td>
          <td>
            <span>{{ item.id }}</span>
          </td>
          <td>
            <router-link
              class="tbl-link"
              :to="item.id"
              append
            >
              VER DETALLE
            </router-link>
          </td>
        </tr>
      </template>
      <template v-if="tab == 'expired'">
        <tr>
          <th><span>SALIDA</span></th>
          <th><span>NÚMERO</span></th>
          <th><span>TITULAR</span></th>
          <th>&nbsp;</th>
          <th><span>PRECIO DE VIAJE</span></th>
        </tr>
        <tr
          v-for="(item, i) in reservations.expired"
          :key="i"
          :class="'reservation-' + item.status"
        >
          <td>
            <span>{{ item.departure_alias }} {{ item.departure_name }}</span>
          </td>
          <td>
            <span>{{ item.id }}</span>
          </td>
          <td>
            <span>{{ item.holder }}</span>
          </td>
          <td>
            <strong>VENCIO EL: {{ item.expiration }}</strong>
          </td>
          <td>
            <strong>{{ item.price_currency }} {{ item.price_final }}</strong>
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>
<script>
import { search } from '@/utils'

export default {
  computed: {
    tabs () {
      return [
        {
          link: { name: 'reservations', query: { tab: 'finalized' } },
          text: 'Reservas por vencer'
        },
        {
          link: { name: 'reservations', query: { tab: 'acredited' } },
          text: 'Reservas confirmadas'
        },
        {
          link: { name: 'reservations', query: { tab: 'canceled' } },
          text: 'Reservas canceladas'
        },
        {
          link: { name: 'reservations', query: { tab: 'expired' } },
          text: 'Reservas vencidas'
        }
      ]
    },
    reservations () {
      const reservations = search(this.$store.state.reservations, this.search).map(
        el => el.data
      )

      return {
        expired: reservations.filter(({ status }) => status == 'expired'),
        canceled: reservations.filter(({ status }) => status == 'canceled'),
        finalized: reservations.filter(({ status }) => status == 'finalized'),
        acredited: reservations.filter(({ status }) => status == 'acredited')
      }
    },
    tab () {
      return (
        this.$route.query.tab ||
				['finalized', 'acredited', 'expired', 'canceled'].reduce(
				  (a, status) =>
				    a || (this.$store.state.reservations.some(
				        ({ data }) => data.status == status
							  )
				        ? status
				        : a),
				  null
				) ||
				'finalized'
      )
    }
  },

  data () {
    return {
      search: null
    }
  }
}
</script>
